import { Injectable } from '@angular/core';
import { JwtHelperService } from "@auth0/angular-jwt";
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthorizationService {

  static TOKEN_STORE_ITEM_NAME = "jwt_nueva";
  jwtHelper: JwtHelperService

  public authenticated: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor() {
    this.jwtHelper = new JwtHelperService();
    if (this.getToken() && !this.isTokenExpired()) {
      this.authenticated.next(true);
    }
  }

  getToken(): string {
    return localStorage.getItem(AuthorizationService.TOKEN_STORE_ITEM_NAME);
  }

  removeToken() {
    localStorage.removeItem(AuthorizationService.TOKEN_STORE_ITEM_NAME);
    this.authenticated.next(false);
  }

  setToken(token: string) {
    if (token && token != "") {
      localStorage.setItem(AuthorizationService.TOKEN_STORE_ITEM_NAME, token);
      this.authenticated.next(true);
    } 
  }

  isTokenExpired() {
    var token = this.getToken();
    if (token) {
      return this.jwtHelper.isTokenExpired(token);
    } else {
      return true;
    }
  }
}
